import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export const useStoreUserValue = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({value, keyIdentifier}: {value: string; keyIdentifier: string}) => {
      const path = '/distributeduserstorage'
      return (
        await ApiClient.axiosInstance.post<ResponseType>(path, {
          keyIdentifier,
          value
        })
      ).data
    },
    onSuccess: async (data: ResponseType) => {
      await queryClient.setQueryData(['userStorageQuery', 'pm-user-groups'], data)
      return data
    }
  })
}
